// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1LBww","topBottomGutter":"Layout_topBottomGutter__Sj_zo"};